import { Button } from "@/components/ui/button";
import { CheckCircle, Star, ThumbsUp } from "lucide-react";

interface ChamadoThanksProps {
  rating: number | null;
  onBackToList: () => void;
}

export default function ChamadoThanks({
  rating,
  onBackToList,
}: ChamadoThanksProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px] my-20">
      <div className=" mx-auto text-center space-y-5">
        {/* Success Animation Area */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
            <div className="absolute -top-2 -right-2">
              <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
                <Star className="w-5 h-5 text-yellow-600 fill-current" />
              </div>
            </div>
            <div className="absolute -bottom-2 -left-2">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <ThumbsUp className="w-5 h-5 text-blue-600" />
              </div>
            </div>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-n-green">
          O seu chamado foi finalizado!
        </h2>

        {/* Content */}
        <div className="space-y-4">
          <div className="bg-gray-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              Obrigado pela sua avaliação!
            </h3>
            <p className="text-gray-600">
              Assim podemos oferecer um serviço cada vez melhor para você.
            </p>
            {rating !== null && (
              <div className="mt-4 flex items-center justify-center gap-2">
                <span className="text-sm text-gray-600">Sua nota:</span>
                <div className="bg-n-beige text-n-green px-3 py-1 rounded-full font-semibold">
                  {rating}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Action Button */}
        <Button onClick={onBackToList} className="w-full h-10">
          Voltar aos chamados
        </Button>
      </div>
    </div>
  );
}
